import "./App.css";
import Navbar from "./components/Navbar";
import Profile from "./components/Profile";
import Services from "./components/Services";
import Home from "./pages/Home";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";

function App() {
  return (
    <div className="App" id="home">
      <Navbar />
      <Home />
      <Profile />
      <Services />
      <ContactForm />
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
